import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import { Heading6, SmallText } from '../styleguide'

import formatDateTime from '../utils/formatDateTime'

const styles = {
  containerStyle: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  }
}

const NewsContent = ({
  date,
  headline,
  text,
  isUnread,
  isPreview = false,
  classes
}) => {
  const [formattedDate] = formatDateTime(date)

  return (
    <div className={classes.containerStyle}>
      <SmallText style={{ color: isUnread ? '#e40045' : '#838a92' }}>
        {formattedDate}
      </SmallText>
      <Heading6 gutterBottom>{headline}</Heading6>
      <SmallText noWrap={isPreview}>{text}</SmallText>
    </div>
  )
}

export default withStyles(styles)(NewsContent)



// WEBPACK FOOTER //
// ./src/components/NewsContent.js